import styled from "styled-components";
import { ANIMATION, SPACING, TOUCH_TARGET } from "../../utils/constants";
import type { ButtonSize } from "../Button/types";

const DIMENSION: Record<ButtonSize, number> = {
  small: SPACING.lg + SPACING.xs,
  medium: SPACING.xl,
  large: TOUCH_TARGET,
};

export const StyledIconButton = styled.button<{ $size: ButtonSize }>`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => DIMENSION[$size]}px;
  height: ${({ $size }) => DIMENSION[$size]}px;
  padding: 0;
  border: none;
  border-radius: ${SPACING.xs + SPACING.xxs}px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: ${({ $size }) => ($size === "small" ? "var(--text-lg)" : "var(--text-xl)")};
  cursor: pointer;
  transition:
    background ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut},
    color ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut};

  &:hover:not(:disabled) {
    background: var(--hover-background);
    color: var(--color-text-default);
  }

  &:focus {
    outline: none;
  }
  &:focus-visible {
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  & > svg {
    flex: none;
    font-size: inherit;
  }
`;
